module.exports = __webpack_public_path__ + "img/helpQRcode.f9dbed30.png";